module.exports = __webpack_public_path__ + "static/img/1_1_2.fe83ab6c.jpg";